import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@cime/shared';
import { ThemeProvider, TooltipProvider } from '@cime/shared';
import { router } from './router';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Défaut volontairement conservateur : aucune requête ne refetch au focus
      // sauf opt-in explicite via le preset SEMI_FRESH (lib/queryPresets.ts).
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <TooltipProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton duration={4000} />
      </TooltipProvider>
    </ThemeProvider>
  </QueryClientProvider>,
);
